import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useFormik } from "formik";
import { AddDispositionSchema } from "../../Validation";
import { useMutation, useQuery } from "react-query";
import { toast } from "sonner";
import { Disposition_StatusList_Add } from "../../Api";
import { useLocation } from "react-router-dom";

interface PropsType {
    show: boolean;
    setShow: (v: boolean) => void;
    value: string;
    number: string;
    initialvalue: any;
}

export default function AddStatus({
    show,
    setShow,
    value,
    number,
    initialvalue
}: PropsType) {
    const { state } = useLocation();
    const { mutate } = useMutation(Disposition_StatusList_Add, {
        mutationKey: "Create_Disposition_Status",
        onSuccess: (data: any) => {
            initialvalue.refetch()
            resetForm();
            setShow(false);
            toast.success(data?.data?.message || "Status Added Successfull,");
        },
        onError: (data: any) => {
            setSubmitting(false);
            toast.error(data?.response?.data?.message || "Something wrong.");
        },
    });

    const { errors, resetForm, isSubmitting, handleSubmit, setSubmitting } =
        useFormik({
            initialValues: { status: value || "", campaign_id: state?.id, number: number || "" },
            enableReinitialize: true,
            validationSchema: AddDispositionSchema,
            onSubmit: (data) => {
                mutate({ status: value, campaign_id: state?.id, number: number });
            },
        });

    return (
        <Modal show={show} centered onHide={() => setShow(false)} backdrop="static">
            <Modal.Body>
                <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3">
                        <h5 className="text-center">
                            Are you sure you want to Change this Status?
                        </h5>
                    </div>

                    <Modal.Footer className="d-flex justify-content-center border-0">
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={isSubmitting}
                            style={{ minWidth: 76.5 }}
                        >
                            {isSubmitting ? (
                                <>
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    <span className="ps-2">Processing...</span>
                                </>
                            ) : (
                                "Yes"
                            )}
                        </Button>
                        <Button
                            style={{ width: 76.5 }}
                            variant="secondary"
                            onClick={() => {
                                setShow(false);
                                resetForm();
                            }}
                        >
                            No
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal.Body>
        </Modal>
    );
}
